module.exports = __webpack_public_path__ + "static/media/search.2f17cd98.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/search.mp4
// module id = 75
// module chunks = 0